import { KeyRound } from 'lucide-react'

import { SplitsAvatar } from '~/components/SplitsAvatar'
import {
  Timestamp,
  Tooltip,
  TooltipLabel,
} from '~/components/component-library'
import { OrgEOASigner } from '~/types'
import { EvmAddress } from '~/utils/address'
import { shortenAddress } from '~/utils/addresses'
import { cn } from '~/utils/tailwind-utils'

export const EoaIconWithTooltip = ({
  signer,
  iconOnly = false,
}: {
  signer: OrgEOASigner
  iconOnly?: boolean
}) => {
  const { address, name, createdAt, lastVerifiedAt } = signer
  const activityTimestamp = lastVerifiedAt ?? createdAt
  const activityLabel = lastVerifiedAt ? 'Last verified' : 'Added'

  return (
    <Tooltip
      content={
        <TooltipLabel
          title={name ?? shortenAddress(address)}
          detail={
            <>
              {name && <span>{shortenAddress(address)}</span>}
              {activityTimestamp && (
                <span>
                  {activityLabel}{' '}
                  <Timestamp
                    timestamp={activityTimestamp}
                    type="relative"
                    abbreviate
                    showTooltip={false}
                  />
                </span>
              )}
            </>
          }
        />
      }
      triggerClassName={cn(
        'relative flex h-6 w-6 items-center justify-center rounded-full border-[2px] border-white transition-[margin] duration-150 dark:border-black',
        {
          'bg-surface-strong': iconOnly,
          'overflow-hidden': !iconOnly,
        },
      )}
    >
      {iconOnly ? (
        <KeyRound size={12} className="text-secondary" />
      ) : (
        <SplitsAvatar address={EvmAddress.format(address)} size={20} />
      )}
    </Tooltip>
  )
}
